import {useEffect} from 'react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

const OneTrustScript = () => {
    const {
        app: {commerceAPI}
    } = getConfig()

    const {oneTrust} = commerceAPI
    const {config} = oneTrust || {}

    var oneTrustEnable = false
    var oneTrustDomainScriptTag = null

    try {
        const jsonConfig = JSON.parse(config)
        oneTrustEnable = jsonConfig.enabled
        oneTrustDomainScriptTag = jsonConfig.domainScriptTag
    } catch (e) {
        console.log(e.message)
    }

    useEffect(() => {
        if (oneTrustEnable) {
            // Check if script is already added
            const existingScript = document.querySelector(
                `script[data-domain-script="${oneTrustDomainScriptTag}"]`
            )

            if (!existingScript) {
                const script = document.createElement('script')
                script.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js'
                script.async = true
                script.defer = true
                script.type = 'text/javascript'
                script.charset = 'UTF-8'
                script.setAttribute('data-domain-script', oneTrustDomainScriptTag)

                document.head.appendChild(script)

                script.onload = () => {
                    window.OptanonWrapper = function () {
                        window.dataLayer = window.dataLayer || []
                        window.dataLayer.push({event: 'OneTrustGroupsUpdated'})
                    }
                }
            }
        }
    }, [oneTrustEnable, oneTrustDomainScriptTag])

    return null
}

export default OneTrustScript
